import { restClient } from '@/Core'

/**
 * Перевізник водія для каскаду «Водій → ТЗ». У значенні select-а (і в картці зміни)
 * перевізника немає — беремо з картки користувача. null — власний водій.
 */
export const LoadDriverCarrierTask = async (uuid: string): Promise<any | null> => {
    const user: any = await restClient.get(`/services/users/${uuid}`)
    return user?.carrier ?? null
}
